module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLight.fe25957b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-ExtraLight.woff2
// module id = 316
// module chunks = 3